import classNames from 'classnames'
import FrequentlyAskedQuestions from '../../../store/components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'
import { FrequentlyAskedQuestionsSection as FrequentlyAskedQuestionsSectionType } from '../../LandingPage.types'
import css from './FrequentlyAskedQuestionsSection.styles.scss'

interface FrequentlyAskedQuestionsSectionProps {
  section: FrequentlyAskedQuestionsSectionType
}

// A wrapper around the base FAQ section built for the store pages
const FrequentlyAskedQuestionsSection = ({
  section,
}: FrequentlyAskedQuestionsSectionProps) => {
  // TODO: convert classname checks to props
  const { questions, accordion } = section
  return (
    <div
      className={classNames(css.FrequentlyAskedQuestionsSection__container, {
        [css[
          'FrequentlyAskedQuestionsSection__container--includeVerticalSectionSpacing'
        ]]: false,
        [css['FrequentlyAskedQuestionsSection__container--contrastBackground']]:
          false,
        [css['FrequentlyAskedQuestionsSection__container--fullWidthSection']]:
          true,
      })}
    >
      <FrequentlyAskedQuestions
        accordion={accordion}
        headerVariant="primary"
        questions={questions}
      />
    </div>
  )
}

export default FrequentlyAskedQuestionsSection
